<div class="icon">
  <i class="fa-regular fa-ticket"></i>
</div>
<span class="font-medium-title-large font-color-red-10">
  Gutschein Code existiert bereits
</span>
<span class="font-regular-body-large text-center">
  Dieser Gutschein Code existiert bereits und wurde noch nicht eingelöst. Bitte
  wähle einen anderen.
</span>
<div class="promo-code">
  <span>
    {{ couponCode }}
  </span>
  <div class="copy-button">
    <i class="fa-regular fa-copy" (click)="copyToClipboard(couponCode)"></i>
  </div>
</div>
<div class="flex-r gap-16 justify-center padding-top-16">
  <button
    type="button"
    (click)="closeDialog()"
    class="inwi-icon-text-button-large-primary">
    <div class="button-content">
      <div class="button-icon">
        <i class="fa-regular fa-check-double"></i>
      </div>
      <div class="button-text">Verstanden</div>
    </div>
  </button>
</div>
